export const getIsSpecialDomain = (hostname: string) => {
  const specialCaseDomains = [
    'solidsport.com',
    'sportstage.se',
    'local.sportstage.se'
  ]

  const isSpecialDomain = specialCaseDomains.includes(hostname)
  const isDevelopmentDomain = /.*-solidsport.dev/.test(hostname)

  return isSpecialDomain || isDevelopmentDomain
}
